// extracted by mini-css-extract-plugin
module.exports = {"selectOpportunity":"Opportunity_selectOpportunity__3VV-w"};